export enum UpcBarcodeSubType {
  StandardSize = 1,
  ReducedSize = 2,
}
